import { registerPlugin } from '@capacitor/core';
import { isNativePlatform } from './device';

const NotificationLaunch = registerPlugin('NotificationLaunch');

export async function consumeNotificationLaunchData() {
  if (!isNativePlatform() || !NotificationLaunch?.consumeLaunchData) {
    return null;
  }

  try {
    const data = await NotificationLaunch.consumeLaunchData();
    if (!data || typeof data !== 'object') {
      return null;
    }
    const link = String(data.link || '').trim();
    const title = String(data.title || '').trim();
    if (!link && !title) {
      return null;
    }
    return { data };
  } catch {
    return null;
  }
}

export function bindNotificationLaunchListener(handler) {
  if (!isNativePlatform() || !NotificationLaunch?.addListener) {
    return () => {};
  }

  let remove = () => {};
  NotificationLaunch.addListener('notificationTapped', (data) => {
    if (data && typeof data === 'object') {
      handler({ data });
    }
  }).then((listener) => {
    remove = () => listener.remove();
  }).catch(() => {});

  return () => remove();
}
